import { creatorbase, creatorbaseQueries } from '@round/api';
import { showNotification } from 'helpers';
import { Button } from '@round/whitelabel-ui';
import { useUnlinkProjectShareMutation } from '@round/creatorbase-helpers/api-hooks';
import popoutStyles from '../../../../popout.module.css';

type Props = {
    share: creatorbase.ProjectShare;
    agencyName: string | undefined;
    onBack: () => void;
    onDone: () => void;
};

const UnlinkStep = ({ share, agencyName, onBack, onDone }: Props) => {
    const { unlink, isLoading } = useUnlinkProjectShareMutation();

    const handleUnlink = async () => {
        try {
            await unlink(share.id);
            showNotification('Project unlinked', 'info');
            onDone();
        } catch (error) {
            showNotification(creatorbaseQueries.projectShares.utils.unlink.getErrorMessage(error as Error), 'error');
        }
    };

    return (
        <>
            <div className={popoutStyles.header}>
                <p className={popoutStyles.title}>Unlink project</p>
            </div>
            <div className={popoutStyles.body}>
                <p className={popoutStyles.copy}>
                    <span className={popoutStyles.bold}>{share.project_name}</span> from {agencyName ?? '-'} will leave
                    this project.
                </p>
            </div>
            <div className={popoutStyles.actions}>
                <Button appearance="ghost" disabled={isLoading} onClick={onBack}>
                    Back
                </Button>
                <Button appearance="critical" isLoading={isLoading} onClick={handleUnlink}>
                    Unlink
                </Button>
            </div>
        </>
    );
};

export default UnlinkStep;
